// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconTraining = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-training'}
      data-name='svg-training'
      data-testid='svg-training'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '30'}
      height={height ?? '30'}
      viewBox={viewBox ?? '0 0 30 30'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.2362 18.0364L28.9533 9.20238L25.9682 6.93262L19.36 15.6235C19.1491 15.5867 18.9322 15.5675 18.7108 15.5675C18.1077 15.5675 17.5379 15.7098 17.0332 15.9628L13.7098 13.153C13.7105 13.1246 13.7108 13.0961 13.7108 13.0675C13.7108 10.9964 12.0318 9.31749 9.96077 9.31749C7.88971 9.31749 6.21077 10.9964 6.21077 13.0675C6.21077 13.1766 6.21543 13.2846 6.22456 13.3913L1.04688 19.336L3.87468 21.799L8.47847 16.5131C8.93313 16.709 9.43428 16.8175 9.96077 16.8175C10.5962 16.8175 11.1946 16.6595 11.7191 16.3806L14.9656 19.1254C14.9624 19.189 14.9608 19.2531 14.9608 19.3175C14.9608 21.3886 16.6397 23.0675 18.7108 23.0675C20.7818 23.0675 22.4608 21.3886 22.4608 19.3175C22.4608 18.8675 22.3815 18.4361 22.2362 18.0364ZM18.7108 21.8175C20.0915 21.8175 21.2108 20.6982 21.2108 19.3175C21.2108 17.9368 20.0915 16.8175 18.7108 16.8175C17.3301 16.8175 16.2108 17.9368 16.2108 19.3175C16.2108 20.6982 17.3301 21.8175 18.7108 21.8175ZM12.4608 13.0675C12.4608 14.4482 11.3415 15.5675 9.96077 15.5675C8.58006 15.5675 7.46077 14.4482 7.46077 13.0675C7.46077 11.6868 8.58006 10.5675 9.96077 10.5675C11.3415 10.5675 12.4608 11.6868 12.4608 13.0675Z'
        fill='black'
      />
    </svg>
  );
};

export default IconTraining;
